import { Link } from "react-router-dom";
import Logo from "../assets/imgs/logoshoe1.png";





export const Nav = () => {



  return (

    <section class="relative mx-auto z-10 shadow-md">
      <div class="flex-wrap place-items-center">
        <nav class="flex justify-between bg-white text-black w-screen">
          <div class="px-5 xl:px-12 py-6 flex w-full items-center">
            <div className="flex gap-3 align-center ">
              <img className="w-13 h-14 rounded-full border-4 border-yellow-main b " src={Logo}></img>
              <a class="text-2xl font-bold italic font-heading relative top-2 " href="#">
                StrideGear
              </a>
            </div>

            <ul class="hidden md:flex px-4 mx-auto font-semibold font-heading space-x-12">
              <li><a class="hover:text-gray-200 underline underline-offset-8 decoration-teal-main decoration-4" href="#">Home</a></li>
              <li><a class="hover:text-gray-200 underline underline-offset-8 decoration-yellow-main decoration-4" href="#">Catagory</a></li>
              <li><Link top="/shop" class="hover:text-gray-200 underline underline-offset-8 decoration-teal-main decoration-4">Collections</Link></li>
              <li><a class="hover:text-gray-200 underline underline-offset-8 decoration-yellow-main decoration-4" href="#">Contact Us</a></li>
            </ul>

            <div class="hidden xl:flex items-center space-x-5 items-center">
              <a class="p-1 hover:text-pink-200  hover:rounded-full" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </a>
              <Link to="/checkout" class="flex items-center hover:text-yellow-main">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span class="flex absolute -mt-5 ml-4">
                  <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-teal-main opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-3 w-3 bg-yellow-500">
                  </span>
                </span>
              </Link>

              <a class="flex items-center hover:text-yellow-200" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 hover:text-teal-main" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </a>

            </div>
          </div>

          <a class="xl:hidden flex mr-6 items-center" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 hover:text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span class="flex absolute -mt-5 ml-4">
              <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-pink-400 opacity-75"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-pink-500">
              </span>
            </span>
          </a>
          <a class="navbar-burger self-center mr-12 xl:hidden" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 hover:text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </a>
        </nav>
      </div >
    </section>
  )
}

export default Nav;

